var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-7{fill:#f2f2f2;}.cls-1,.cls-2,.cls-4,.cls-5,.cls-6,.cls-7{stroke:#000;stroke-linecap:round;}.cls-1,.cls-4,.cls-5,.cls-6,.cls-7{stroke-linejoin:round;}.cls-1,.cls-2,.cls-4{stroke-width:5px;}.cls-2{fill:#668bff;stroke-miterlimit:10;}.cls-3{fill:#070606;}.cls-4,.cls-5,.cls-6{fill:none;}.cls-5{stroke-width:5.02px;}.cls-6{stroke-width:6.56px;}.cls-7{stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1110.43,1200H89.57c1.58-51.7,7.28-106.47,24.11-113.09,32.75-12.86,289.07-148.61,313.91-166.47,9.94-7.15,23.59-14.18,38.87-20.8,12.15-5.26,25.34-10.28,38.54-14.9,1.64-.58,3.27-1.14,4.91-1.7,16.95-5.81,33.72-10.94,48.09-15.1,24.44-7.07,42-11.33,42-11.33s12.54,3,31.15,8.24c16.11,4.51,36.79,10.64,57.82,17.81l.84.29c15.19,5.2,30.54,10.95,44.48,17a259.05,259.05,0,0,1,29.2,14.67c2.42,1.45,4.72,2.91,6.87,4.37.7.48,1.39,1,2,1.43,24.84,17.86,281.16,153.61,313.91,166.47C1103.15,1093.53,1108.85,1148.3,1110.43,1200Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M689.81,1048.11c0,72.78-184.81,72.78-184.81,0v-242H689.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M562,1200H462.3c-40.24-48.6-76.1-93.72-78.79-103.36-6.13-22,106.9-87.85,99.54-92.93s-89.2-6.75-91.3-20.27c-.9-5.76,16.06-33.29,35.84-63,26.62-40,58.35-84,58.35-84,3.61-5.2,6.71-7.75,9.36-8.12,4.29-.64,7.42,4.37,9.7,12.95,2.68,10.1,4.15,25.16,4.91,41.75,1.82,39.84-.55,88.51-.52,98.71,0,5.21,6.06,32,15,68.9,2.88,11.88,6.06,24.79,9.44,38.37C542.5,1123.78,552.45,1162.9,562,1200Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M815.36,1096.64c-2.68,9.64-38.55,54.76-78.78,103.36H636.9c9.78-38,20-78.24,28.8-113.65,2.69-10.84,5.25-21.21,7.62-31,9.59-39.34,16.16-68.2,16.17-73.64,0-10.23-2.35-59.17-.52-99.09.22-4.7.49-9.27.84-13.64,1.14-14.31,3-26.43,6-33.64,3.73-9,9.19-10.34,17.12,1.08,0,0,29.22,40.48,55.12,79.1l2.3,3.45c20.16,30.25,37.69,58.59,36.77,64.43-2.1,13.52-83.94,15.21-91.31,20.27S821.5,1074.67,815.36,1096.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M814.42,583c0,157.39-160.29,285-216,294.67S375.73,740.39,375.73,583s98.2-285,219.34-285S814.42,425.61,814.42,583Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M510.18,343.23c8.7,6.64,1.51,13.28,10.2,19.92A180.67,180.67,0,0,1,584,317.74c4.18-1.77,8.71-3.4,13.15-2.49,4.12.85,7.48,3.78,10.35,6.86a69.37,69.37,0,0,1,17.7,55.6l25.33-15.46a176.11,176.11,0,0,0,46.64,76.2l7.6-23.14c41,22.18,68.72,64.95,79,110.52s6.13,131.65,18.9,125.29c-19.75,48.56-36.24,88.15-69.06,129,8,1.49-28.8,16.87-23,11.14-26.83,28.53-18.38,49.41-5,86.25,8.54,23.48,45,40,69.84,38.43,25.46-1.58,46.59-19.23,66.89-34.71S887.19,851,912.13,856.3c-10.3-27.66,11.08-54.51,20.25-79.31a307.14,307.14,0,0,0,18-82.69c4.27-55.27-6.11-111.84-31.23-161.37-10.53-20.78-23.9-42.47-20.48-65.52L918,479.66c7.63-26.29-5.94-53.7-20.23-77.06-31.38-51.3-35.22-109.69-75.28-157.42-32.23-38.4-74.24-69.27-122.38-84.28-66.57-20.76-144.68-8.18-195.83,39.22-3.89,3.6-8,7.58-13.3,8.16-4.35.48-8.55-1.5-12.58-3.23-39.41-17-87-13.44-123.49,9.2-29.35,18.22-50.39,46.9-70.68,74.87l36.76-4.5a879,879,0,0,0-48.93,83.21c-9.12,17.66-17.73,35.91-21.17,55.48-4.12,23.53-.56,47.66-1.15,71.54-.7,28.54-15.86,49.4-21.37,76.14a155.25,155.25,0,0,0-2.7,47.44c.66,6.15,14.51,42.44,13.21,44.61a28.46,28.46,0,0,1,20.54-13.34c-3.66,39-7,80,9,115.72,6.81,15.18,16.73,30.28,27.33,43.09,8.05,9.72,13.88,21.25.34,31,5.21-3.74,25,14.64,28.07,18.07,8.23,9.26,10.33,20.71,16.85,30.55,14,21.06,43.55,33.94,68,34.31,30.58.47,89-12,101.56-39.9s3.56-60.45-20-80c-1.59,3.37-13.34-2.61-14.94.76C439.88,768.74,409,727.82,390.74,660c6.07.09,6.27-72.69,4.09-109.11-2.41-40.48-5.58-78.2,28.32-102.81,18.72-13.59,34.14-27,47-46.59C473.48,396.51,507.14,340.91,510.18,343.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M623.18,585.65c-5.68,1.23-10.68,12.47-4.43,23.73s6.25-8.76,6.25-8.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M560.18,585.65c5.68,1.23,10.68,12.48,4.43,23.73s-6.25-8.76-6.25-8.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M417.31,541.93c0-19.06,147.25-19.06,147.25,0,0,0,0,124.24-73.63,124.24S417.31,541.93,417.31,541.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M618.47,541.93c0-19.06,147.25-19.06,147.25,0,0,0,0,124.24-73.63,124.24S618.47,541.93,618.47,541.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M620.39,568.23c0-17.86-57.75-17.86-57.75,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 757.82,
    y1: 535.13,
    x2: 785.22,
    y2: 538.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 419.97,
    y1: 536.3,
    x2: 384.9,
    y2: 539.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M552.23,653c-5.56,0-7,12.5,0,16.67s20.26-13.14,24.75-4.88c5.31,9.8,20.12,13.29,27.24-.59,4.55-8.87,14.64,3.39,22.32,2.35s7.53-15.55.6-18.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M548.38,732.88c3,45.85,80.79,45.85,83.09,0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 686.72,
    cy: 582.11,
    rx: 13.36,
    ry: 18.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M693.89,571.26c4.5.11,13.85-5.74,13.85-8.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M685.71,567.75c4.49.11,13.84-5.73,13.84-8.07"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 493.13,
    cy: 582.11,
    rx: 13.36,
    ry: 18.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M486,571.26c-4.49.11-13.84-5.74-13.84-8.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M494.14,567.75c-4.49.11-13.85-5.73-13.85-8.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.46,510.15c10.62-27.74,106.48-29.13,114.54,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M747.41,510.15c-10.62-27.74-106.47-29.13-114.53,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M808.26,534.7s52.16-4.48,52.16,52.36-59.29,78.43-59.29,78.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.34,534.7s-52.16-4.48-52.16,52.36,59.29,78.43,59.29,78.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M745.48,653.34s4.24,5.12,6.79,7.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M752.74,642.45s4.24,5.11,6.79,7.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M434,653.34s-4.25,5.12-6.8,7.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M426.68,642.45s-4.24,5.11-6.79,7.67"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 672.62,
    cy: 690.46,
    r: 4.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar02);
export default __webpack_public_path__ + "static/media/Avatar-02.d5c45cbe2f35ef5ca35d7dcd0589c454.svg";
export { ForwardRef as ReactComponent };